module.exports = __webpack_public_path__ + "img/AcademyTopPictureOffer.f13d4d61.png";